import { environment } from '../environments/environment';

export class Logging {

    public static log(msg:any, othermsg?:any){
        if(environment.consoleLogging){
            if(othermsg){
                console.log(msg , othermsg);
            }else{
                console.log(msg);
            }
            
        }
        
    }

    public static error(msg:any, othermsg?:any){
        if(environment.consoleLogging){
            if(othermsg){
                console.error(msg , othermsg);
            }else{
                console.error(msg);
            }
            
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/app/logging.ts